import BraintreeCardPayment from './BraintreeCardPayment';
import BraintreePayPalPayment from './BraintreePayPalPayment';
import BraintreeLocalPayment from './BraintreeLocalPayment';
import BraintreeGooglePayPayment from './BraintreeGooglePayPayment';

export default class BraintreePaymentServiceProvider {
	constructor() {
		this.paymentType = window.dataLayer[0].order?.paymentType?.toUpperCase();
		this.braintreePaymentMethodsMap = {
			CARD: BraintreeCardPayment,
			PAYPAL: BraintreePayPalPayment,
			IDEAL: BraintreeLocalPayment,
			BANCONTACT: BraintreeLocalPayment,
			EPS: BraintreeLocalPayment,
			GOOGLEPAY: BraintreeGooglePayPayment,
		};
		this.init();
	}

	init() {
		this.showLocalPaymentError();
		this.handleCardPayment();
		this.handleOtherPaymentTypes();
	}

	handleCardPayment() {
		const isBillingPage = !!document.getElementById('braintreePaymentForm');
		if (isBillingPage) {
			new this.braintreePaymentMethodsMap.CARD();
		}
	}

	handleOtherPaymentTypes() {
		const isOrderReviewPage = !!document.getElementById('orderReviewForm');
		const isValidBraintreePayment =
			this.paymentType in this.braintreePaymentMethodsMap;
		const isNotCardType = this.paymentType !== 'CARD';
		if (isOrderReviewPage && isValidBraintreePayment && isNotCardType) {
			new this.braintreePaymentMethodsMap[this.paymentType]();
		}
	}

	showLocalPaymentError() {
		const { isLocalPaymentDeclined } = sessionStorage;
		if (isLocalPaymentDeclined) {
			const errorMessage = document.getElementById('localPaymentError');
			errorMessage.removeAttribute('hidden');
			sessionStorage.removeItem('isLocalPaymentDeclined');
		}
	}
}
